exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bigChart {\n    height: 500px;\n}\n\n.smallChart {\n    height: 300px;\n    width: 300px;\n}\n\n.miniChart {\n    height: 40px;\n}\n\n.vspace {\n    height: 15px;\n}\n\n.election {\n    background-color: steelblue;\n}\n\n.republican {\n    fill: brown;\n}\n\n.bar {\n    fill: steelblue;\n}\n\n.bar:hover {\n    fill: brown;\n}\n\n.axis {\n    font: 10px sans-serif;\n}\n\n.axis path,\n.axis line {\n    fill: none;\n    stroke: #000;\n    shape-rendering: crispEdges;\n}\n\n.area {\n  fill: steelblue;\n}\n\n/* line chart specifics.*/\n.line {\n    fill: none;\n    stroke: steelblue;\n    stroke-width: 1.5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/css/chart.css
// module id = 631
// module chunks = 0